<script setup lang="ts">
import { cta } from '../../../content'
</script>

<template>
  <section id="cta" class="cta">
    <div class="container">
      <h2 class="cta__title animate animate--fade-up">{{ cta.headline }}</h2>
      <p class="cta__description animate animate--fade-up animate--delay-1">{{ cta.lead }}</p>

      <div class="cta__actions animate animate--fade-up animate--delay-2">
        <a
          v-for="btn in cta.buttons"
          :key="btn.label"
          :href="btn.href"
          :class="btn.style === 'stroke' ? 'btn btn--white-outline btn--lg' : 'btn btn--white btn--lg'"
        >
          {{ btn.label }}
        </a>
      </div>
    </div>
  </section>
</template>
